module.exports = __webpack_public_path__ + "img/jizuo.prt.268c2389.jpg";